import { Directive } from '@angular/core';

/**
 * @hidden
 */
@Directive({
    selector: '[igxComboHeader]'
})
export class IgxComboHeaderDirective {
}

/**
 * @hidden
 */
@Directive({
    selector: '[igxComboFooter]'
})
export class IgxComboFooterDirective {
}

/**
 * @hidden
 */
@Directive({
    selector: '[igxComboItem]'
})
export class IgxComboItemDirective {
}

/**
 * @hidden
 */
@Directive({
    selector: '[igxComboEmpty]'
})
export class IgxComboEmptyDirective {
}

/**
 * @hidden
 */
@Directive({
    selector: '[igxComboHeaderItem]'
})

export class IgxComboHeaderItemDirective {
}

/**
 * @hidden
 */
@Directive({
    selector: '[igxComboAddItem]'
})
export class IgxComboAddItemDirective {
}

/**
 * @hidden
 */
@Directive({
    selector: '[igxComboToggleIcon]'
})
export class IgxComboToggleIconDirective {
}

/**
 * @hidden
 */
@Directive({
    selector: '[igxComboClearIcon]'
})
export class IgxComboClearIconDirective {
}

